// Certification Models
import { createCertificationSchemaStoreDefaultModel } from './schema/certification-schema.store'
import { createCertificationRequirementStoreDefaultModel } from './requirement/certification-requirement.store'
import { createCertificationProcessStoreDefaultModel } from './process/certification-process.store'
import { createCertificationProcedureStoreDefaultModel } from './procedure/certification-procedure.store'
import { createCertificationParticipatedIndustriesStoreDefaultModel } from './participated-industries/certification-participated-industries.store'

const certificationContentModels = {
  certificationSchema: createCertificationSchemaStoreDefaultModel(),
  certificationRequirement: createCertificationRequirementStoreDefaultModel(),
  certificationProcess: createCertificationProcessStoreDefaultModel(),
  certificationProcedure: createCertificationProcedureStoreDefaultModel(),
  certificationParticipatedIndustries: createCertificationParticipatedIndustriesStoreDefaultModel(),
}

export { certificationContentModels }
